<template lang="pug">
    article.news-item
        BlockVisibilityTrigger(:theme='"black"')

        .news-item__wrap
            .news-item__content
                .news-item__photo
                    //- img(v-if='news.photofeature' :src='getImage(news.photofeature)', :alt='news.title')
                    img(v-if='news.photofeature' :src='`${base}/api/news/img/${news.photofeature}`', :alt='news.title')
                .news-item__description
                    h1.h1.news-item__title(v-html="news.title")
                    .news-item__text(v-html='news.text')
                
                    ShareNews(
                        :id='news.id'
                        :title='news.title'
                        :description='news.lead',
                        :img='getImage(news.photofeature)'
                        )

            router-link.news-item__btn(
                to='/news',
                v-html='data.all')

        Footer

</template>

<script>
import newsData from '../assets/data/newsinfo.json';
import Footer from '../components/Footer.vue';
import BlockVisibilityTrigger from '../components/BlockVisibilityTrigger.vue';
const base = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : '';

export default {
    name: 'NewsTest',

    components: {
        Footer,
        BlockVisibilityTrigger,
        ShareNews: () => import('@/components/ShareNews.vue')
    },

    props: {
        id: String
    },

    data() {
        return {
            data: newsData,
            news: {},
            base
        };
    },

    beforeMount() {
        this.$http
            .get(`${base}/api/news/${this.$props.id}`)
            .then(res => {
                this.news = res.data;
            })
            .catch(() => {
                this.$router.push('/news');
            });
    },

    methods: {
        getImage(path) {
            path;
            // axios
            //     .get(`http://localhost:3000/api/news/img/${path}`)
            //     .then(res => {
            //         console.log(res);
            //     })
            //     .catch(e => {
            //         console.log(e);
            //         return require(`@/assets/img/news/nophoto.jpg`);
            //     });
            // console.log()
            // try {
            //     return require(`http://localhost:3000/api/news/img/${path}`);
            // } catch (e) {
            //     return require(`@/assets/img/news/nophoto.jpg`);
            // }
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';

.news-item {
    padding-top: 8em;

    @media (--viewport-tablet) {
        padding-top: 5em;
    }

    &__wrap {
        width: calc(var(--layout-column-width) * 8 + var(--layout-gutter-width) * 7);
        margin: 0 auto;
        padding-bottom: 11.2em;

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
            padding-bottom: 5em;
        }
    }

    &__title {
        text-align: center;
        color: var(--color-main-text);
        width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin: 0 auto;
        margin-bottom: 1.6em;

        @media (--viewport-tablet) {
            width: 100%;
            margin-bottom: 1.5em;
        }
    }

    &__content {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 4em;
    }

    &__photo {
        position: relative;
        max-height: 60vh;

        img {
            width: 100%;
            object-fit: cover;
        }
    }

    &__description {
        position: relative;
        font-size: 0.6em;
        flex-grow: 1;
        padding-top: 7em;
        background-color: var(--color-main-bg);

        @media (--viewport-tablet) {
            font-size: 1em;
            padding: 1.5em calc(var(--layout-column-width) + var(--layout-gutter-width)) 2.3em;
        }
    }

    &__date {
        font-weight: 350;
        text-align: center;
        margin-bottom: 4em;

        @media (--viewport-tablet) {
            position: absolute;
            top: -1.5em;
            left: 0;
            font-size: 1em;
            text-align: left;
            padding: 0.3em calc(var(--layout-column-width) + var(--layout-gutter-width));
            margin-bottom: 1em;
            background-color: var(--color-main-bg);
        }
    }

    &__name {
        font-family: var(--font-accent);
        text-transform: uppercase;
        margin-bottom: 4em;
        text-align: center;

        @media (--viewport-tablet) {
            text-align: left;
            margin-bottom: 1em;
        }
    }

    &__text {
        font-size: 1.33em;
        width: calc(var(--layout-column-width) * 4 + var(--layout-gutter-width) * 3);
        margin: 0 auto 7.1em;
        // column-count: 2;
        // column-gap: var(--layout-gutter-width);

        @media (--viewport-tablet) {
            font-size: 1em;
            width: 100%;
            column-count: 1;
            margin-bottom: 2em;
        }

        ul {
            list-style: disc;

            li {
                margin-bottom: 10px;
            }
        }

        b,
        strong {
            font-weight: 500;
        }

        p {
            margin-bottom: 1.4em;
        }
    }

    &__btn {
        display: table;
        color: var(--color-accent-text);
        font-family: var(--font-accent);
        text-transform: uppercase;
        text-decoration: none;
        padding: 0.5em 0.5em 0.3em;
        border: 4px solid var(--color-main-bg);
        margin: 0 auto;

        &:hover,
        &:focus {
            color: var(--color-main-text);
            background-color: var(--color-main-bg);
            border: 4px solid transparent;
        }
    }
}
</style>
